import {Button, Table, Spin, Modal} from 'antd';
import Header from '../../../components/HeaderList';
import {ReactComponent as Edit} from '../../../assets/icons/edit.svg';
import {ReactComponent as Trash} from '../../../assets/icons/trash.svg';
import {getColumnSearchProps} from '../../../utils/tables';
import Editor from './Editor';
import styles from '../styles/VehiclesUI.module.css';

const VehiclesUI = props => {
  const {
    loading,
    vehicles,
    vehicle,
    branches,
    openEditor,
    editorVisible,
    closeEditor,
    newVehicle,
    confirmDelete,
    handleVehicle,
  } = props;

  const getStatus = status => {
    if (status === 'active') {
      return 'Activa';
    }
    return 'Mantenimiento';
  };

  const getLocationName = location => {
    let name = '-';
    const index = branches.findIndex(el => el.id === location);
    if (index > -1) {
      name = branches[index].name;
    }
    return name;
  };


  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      align: 'center',
    },
    {
      title: 'Placa',
      dataIndex: 'plate',
      align: 'center',
      ...getColumnSearchProps('plate'),
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      align: 'center',
      render: val => getStatus(val),
    },
    {
      title: 'Tienda',
      dataIndex: 'locationId',
      align: 'center',
      render: val => getLocationName(val),
    },
    {
      title: 'Editar',
      align: 'center',
      dataIndex: 'id',
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          <div className={styles.divider} />
          <div className={styles.delete} onClick={() => confirmDelete(id)}>
            <Trash />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        back="/ajustes"
        title="Listado de vehiculos"
        actions={
          <Button
            onClick={newVehicle}
            type="primary"
            size="large"
            className="main-button">
            AGREGAR VEHICULO
          </Button>
        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Table
            columns={columns}
            dataSource={vehicles}
            rowKey="id"
          />
        </div>
      )}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={600}
      >
        <Editor
          close={closeEditor}
          vehicle={vehicle}
          branches={branches}
          handleVehicle={handleVehicle}
        />
      </Modal>
    </div>
  );
};

export default VehiclesUI;
